/** @file Click modifiers -> selection mode: Ctrl/Cmd toggles, Shift adds, plain replaces. */
import type { ViewportPointer } from '../../panels/viewport/viewportTypes';
import type { SelectMode } from '../../stores/updateSelection';

/** R-E1-11. */
export function selectModeOf(p: Pick<ViewportPointer, 'ctrl' | 'shift'>): SelectMode {
  if (p.ctrl) return 'toggle';
  return p.shift ? 'add' : 'replace';
}
